module.exports = __webpack_public_path__ + "media/images/emblems/Meyrin-coat_of_arms-c7f802a8be102f52cd0795d0be52e4ff.svg";